import React from 'react';
import { motion } from 'framer-motion';

export default function Video({ src }) {
  const animationProps = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <motion.video
      src={src}
      className="rounded-xl"
      {...animationProps}
      controls
      alt="Sent video"
    />
  );
}
